import React from "react"
import Modal from "./Modal"

export default function Header(){

    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [btnContent, setBtnContent] = React.useState("")

    function infoIconClick(){
        setModalIsOpen(true)
        setBtnContent("about")
    }

    function helpIconClick(){
        setModalIsOpen(true)
        setBtnContent("how-to")
    }

    return (
        <div className="header">

            <Modal
                isOpen={modalIsOpen}
                setModalIsOpenBtn={setModalIsOpen}
                btnContent={btnContent}
            >
            </Modal>

            <img src={require("../assets/info.png")} alt="info icon" width="25" height="25" onClick={infoIconClick} />
            <h2 className="header-title">Jungle Jumble</h2>
            <img src={require("../assets/help.png")} alt="help icon" width="25" height="25" onClick={helpIconClick} />
        </div>
    )
}
